'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var headerRow = require('./header-row-803701f0.js');
var tableRows = require('./table-rows-fbf18b79.js');

var TableContent = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, columns = _a.columns, rows = _a.rows, onToggleRow = _a.onToggleRow;
    if (!columns) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(headerRow.HeaderRow, { columns: columns, dataCy: dataCy, dataTestId: dataTestId }),
        React__default.createElement(tableRows.TableRows, { rows: rows, columns: columns, dataCy: dataCy, dataTestId: dataTestId, onToggleRow: onToggleRow })));
};

exports.TableContent = TableContent;
